import angular from 'angular';
import socialSecuritySearchComponent from './socialSecuritySearch.component';

let socialSecuritySearchModule = angular.module('socialSecuritySearch', [
])

.component('socialSecuritySearch', socialSecuritySearchComponent)

.name;

export default socialSecuritySearchModule;



// WEBPACK FOOTER //
// ./client/app/social-security.module/components/socialSecuritySearch/socialSecuritySearch.js